import { combineReducers } from 'redux';
import mapValues from 'lodash/mapValues';
import { parseValidatorSchema } from '../../utils/SchemaParser';
import * as InspectionActionTypes from '../inspection/inspection.actionTypes';
const allIds = (state = [], action) => {
  switch (action.type) {
    case InspectionActionTypes.READ_INSPECTION_SCHEMAS_SUCCESS:
      return action.response.result;
    default:
      return state;
  }
};
const byId = (state = {}, action) => {
  switch (action.type) {
    case InspectionActionTypes.CREATE_INSPECTION_SUCCESS: {
      const formSchemaId =
        action.payload.entities.inspection[action.payload.result].formSchema;
      return {
        ...state,
        [formSchemaId]: parseValidatorSchema(
          action.payload.entities.formSchema[formSchemaId]
        ),
      };
    }
    case InspectionActionTypes.READ_INSPECTION_SUCCESS: {
      const formSchemaId =
        action.response.entities.inspection[action.response.result].formSchema;
      return {
        ...state,
        [formSchemaId]: parseValidatorSchema(
          action.response.entities.formSchema[formSchemaId]
        ),
      };
    }
    case InspectionActionTypes.READ_INSPECTION_SCHEMAS_SUCCESS: {
      const parsedValues = mapValues(
        action.response.entities.formSchemaSchema,
        schema => {
          return parseValidatorSchema(schema.formSchema);
        }
      );
      return {
        ...state,
        ...parsedValues,
      };
    }
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  byId,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/validatorSchema/validatorSchema.reducer.js